import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdDashboard, MdGeneratingTokens, MdOutlineFeed, MdSettingsInputComponent } from 'react-icons/md'
import { CgProfile, CgFeed, CgClipboard } from 'react-icons/cg'
import { FaWallet, FaRobot, FaMoneyBill } from 'react-icons/fa'
import { HiUserGroup } from 'react-icons/hi'
import { TbAffiliate } from 'react-icons/tb'
import { BsFilesAlt } from 'react-icons/bs'
import { GiAccordion, GiPolarStar, GiTransform, GiTwoCoins, GiWantedReward } from 'react-icons/gi'
import { BiBell, BiCurrentLocation, BiStar } from 'react-icons/bi'
import { SiGoogletagmanager, SiBlockchaindotcom } from 'react-icons/si'
import { RiBankCard2Fill, RiListUnordered, RiCopperCoinFill, RiBankFill } from 'react-icons/ri'
import { useAclContext } from "../../contexts/acl";
import { useMainContext } from "../../contexts/main";
import { useWindowSize } from "../common/useWindowSize";
import { MOBILE_SIZE } from "../../constants/common";
import { GoChecklist, GoScreenFull } from "react-icons/go";
import { BiTransfer } from "react-icons/bi";
import { IoAnalyticsSharp } from "react-icons/io5";


const useSidebar = () => {

    const { width } = useWindowSize()
    const navigate = useNavigate()
    const { onSidebarChange } = useMainContext()
    const { permissions, loading } = useAclContext()

    const [routes, setRoutes] = useState(null)
    const [urlDirectAccess, setUrlDirectAccess] = useState(null)

    const onRouteClicked = (idx) => {
        if (routes[idx].items) {
            const newRoutes = [...routes]
            routes[idx].open = !routes[idx].open
            setRoutes(newRoutes)
        } else if (width < MOBILE_SIZE) {
            onSidebarChange()
        }
        navigate(routes[idx].path)
    }


    const onSubRouteClicked = (subrouteIndex, itemIndex) => {
        const items = routes[subrouteIndex]
        const route = items.items[itemIndex]
        navigate(route.path)
        if (width < MOBILE_SIZE) {
            onSidebarChange()
        }
    }

    useEffect(() => {
        if (!loading) {
            const { routes, urlAccess } = getSideRoutes(permissions)
            setRoutes(routes)
            setUrlDirectAccess(urlAccess)
        }
    }, [loading, permissions])


    return {
        urlDirectAccess, routes, onRouteClicked, onSubRouteClicked
    }
}



const getSideRoutes = (perms) => {

    /**
     * dashboard access
     */
    const hasDashboardAccess = perms.panel?.read

    /**
     * users access
     */
    const hasUserAccess = perms.user?.read

    /**
     * files access
     */
    const hasFilesAccess = perms.export?.read

    /**
     * cartable access
     */
    const hasCartableAccess = perms.user?.write

    /**
     * report access
     */
    const hasOrderAccess = perms.order?.read || perms.otc?.read || perms.trade?.read
    const hasCoiningAccess = perms.coining?.read
    const hasBankingAccess = perms.banking?.read
    const hasWagesAccess = perms.trace?.read
    const hasAffiliateAccess = perms.trace?.read || perms.affiliate?.read
    const hasAddressAccess = perms.address?.read
    const hasMultisignatureAccess = perms.multiSignature.read
    const hasAllReportsAccess =
        hasOrderAccess || hasCoiningAccess || hasBankingAccess ||
        hasWagesAccess || hasAffiliateAccess || hasAddressAccess

    /**
     * setting access
     */
    const hasRolesAccess = perms.role?.read
    const hasSettingAccess = perms.setting?.read
    const hasAllSettingAccess = hasSettingAccess || hasRolesAccess

    const urlAccess = {
        '/login': true,
        '/profile': true,
        '/dashboard': hasDashboardAccess,
        '/users': true,
        '/files': hasFilesAccess,
        '/cartable': hasCartableAccess,
        '/bank-accounts': hasUserAccess,
        '/reports': hasAllReportsAccess,
        '/setting': hasAllSettingAccess,
        '/reports/orders': hasOrderAccess,
        '/reports/coin-transactions': hasCoiningAccess,
        '/reports/bank-transactions': hasBankingAccess,
        '/reports/wages-list': hasWagesAccess,
        '/reports/affiliate-overview': hasAffiliateAccess,
        '/reports/addresses': hasAddressAccess,
        '/reports/transfers': true,
        '/reports/staking': true,
        '/reports/rewards': true,
        '/reports/swaps': true,
        '/setting/tokens': hasSettingAccess,
        '/setting/pairs': hasSettingAccess,
        '/setting/roles': hasRolesAccess,
        '/setting/user-levels': hasSettingAccess,
        '/setting/robots': hasSettingAccess,
        '/setting/otc': hasSettingAccess,
        '/setting/wages': hasSettingAccess,
        '/setting/available-coins': hasSettingAccess,
        '/setting/general': hasSettingAccess,
        '/setting/coin-list': hasSettingAccess,
        '/setting/accounting': true,
        '/setting/transfer': true,
        '/setting/staking': true,
        '/setting/swap': true,
        '/setting/suggestions': true,
        '/setting/package': true,
        '/analysis': true, // temporary access
        '/fullnode': hasMultisignatureAccess,
        '/send-notification': true,
        '/reward': true,
    }

    const routes = [
        // { title: 'dashboard', path: '/dashboard', icon: MdDashboard, show: hasDashboardAccess },
        { title: 'users', path: '/users', icon: HiUserGroup, show: true },
        { title: 'package', path: '/setting/package', icon: GoChecklist, show: true },
        { title: 'suggestions', path: '/setting/suggestions', icon: BiStar, show: true },
    ]

    return {
        urlAccess,
        routes
    }
}



export default useSidebar
